export default {
	slider: 20000,
};



// WEBPACK FOOTER //
// ./src/config/timer.config.js